// Sends a failure the donor hit in the browser to the server, which reports it to Sentry (the
// page has no Sentry of its own -- see DonationFlowsController#report_client_error). Best effort:
// never throws and never holds the donor up.
export function reportClientError(url, context, error) {
  if (!url) return

  try {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: JSON.stringify({
        context,
        name: error?.name || "Error",
        message: String(error?.message ?? error),
        stack: error?.stack || "",
        page: window.location.pathname
      }),
      keepalive: true
    }).catch(() => {})
  } catch (_) {
    // Reporting must never be what breaks the checkout.
  }
}
